import { TranslationsContext } from '@telia-common-components/shared';
import React from 'react';
import { Card, CardContent, Grid, GridColumn, Notice, Spinner, ThemeContext } from 'telia-front-react';
import { FetchStatus } from '../../../util/FetchStatus';
import { Go3AppAdditionalInfo } from './Go3AppAdditionalInfo';
import { Go3AppCard } from './Go3AppCard';
import { useGo3AppDetails } from './Go3AppDetailsProvider';
import { Go3AppInclusions } from './Go3AppInclusions';
export const Go3AppDetailsContent = (props) => {
    const { go3AppDetailsState, getApp, fetchGo3AppDetails } = useGo3AppDetails();
    const { translate } = React.useContext(TranslationsContext);
    const { theme } = React.useContext(ThemeContext);
    React.useEffect(() => {
        fetchGo3AppDetails();
    }, [props.lang]);
    if ([FetchStatus.UNINITIALIZED, FetchStatus.FETCHING].includes(go3AppDetailsState.status)) {
        return React.createElement(Spinner, null);
    }
    if (FetchStatus.ERROR === go3AppDetailsState.status || !getApp()) {
        return React.createElement(Notice, { type: "error" }, translate('go3App.generalError'));
    }
    return (React.createElement(Grid, { equalHeight: true },
        React.createElement(GridColumn, { width: ['xs-12', 'lg-8'] },
            React.createElement(Card, null,
                React.createElement(CardContent, { background: theme === 'dark' ? 'neutral-bg-level-1' : 'neutral-bg-level-2' },
                    React.createElement(Grid, null,
                        React.createElement(GridColumn, { width: ['xs-12', 'sm-5'] },
                            React.createElement(Go3AppCard, null)),
                        React.createElement(GridColumn, { width: ['xs-12', 'sm-7'] },
                            React.createElement(Go3AppInclusions, null)))))),
        React.createElement(GridColumn, { width: ['xs-12', 'lg-4'] },
            React.createElement(Go3AppAdditionalInfo, null))));
};
